import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const PreWelcomeAgeVerification = ({ handleNextButtonClick, handleNotAllowed }) => {
  const { sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    sendEvent('open_web_app');
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>Сайт містить<br />контент тільки для користувачів,<br />які досягли повноліття</p>
        <p className={styles.question}>Чи досягли ви повноліття?</p>
        <div className={styles.buttonContainer}>
          <div className={styles.button} onClick={handleNextButtonClick}>
            <img src={getImageFromS3('images/26ua-prl-a-l/short-glass-button.png')} alt="glass-button" />
            <p>Так</p>
          </div>
          <div className={styles.button} onClick={handleNotAllowed}>
            <img src={getImageFromS3('images/26ua-prl-a-l/short-glass-button.png')} alt="glass-button" />
            <p>Ні</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreWelcomeAgeVerification;